import { _t } from '@/locale';
import { ReactNode } from 'react';
import CroLabel from '../CroLabel';
import { DealPriceLine } from './shared';
import { MPMapServiceCardProps, MPServiceCardProps } from './types';

export const getFooterSlots = (
  props: MPServiceCardProps | MPMapServiceCardProps,
): { upper: ReactNode; lower: ReactNode; right: ReactNode } => {
  let upper: ReactNode = null;
  let lower: ReactNode = null;

  if (props.type === 'deal') {
    upper = <DealPriceLine price={props.price} originalPrice={props.originalPrice} />;
    lower = props.duration && <span className="text-fg_secondary text-m font-bold">{props.duration}</span>;
  }

  if (props.type === 'sistaminuten' && props.bookableServicesCountLabel) {
    const hasMatchingServices = props.matchedServicesCount > 0;

    upper = <span className="text-fg_highlight text-l font-bold">{props.bookableServicesCountLabel}</span>;
    lower = (
      <span className="text-fg_secondary text-m line-clamp-[1]">
        {hasMatchingServices ? _t('matchesSearch') : _t('withDiscount')}
      </span>
    );
  }

  const { croLabel, ctaSlot } = props;

  if (ctaSlot) {
    return {
      upper,
      lower: (
        <>
          {lower}
          {croLabel && <CroLabel {...croLabel} showIcon={false} className="w-auto whitespace-nowrap" />}
        </>
      ),
      right: ctaSlot,
    };
  }

  return {
    upper,
    lower: lower || null,
    right: croLabel ? <CroLabel {...croLabel} showIcon className="w-auto whitespace-nowrap" /> : null,
  };
};
